import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Poppins', sans-serif;
  }
  body {
    background: ${({ theme }) => theme.colors.background}; 
  
    background: url('/images/background.jpg') 50% / cover no-repeat #191919;
    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
